// import React from 'react';
// import ReusableTabs from '../../../pages/ReusableTabs';
// import DamagedForm from './DamagedForm';
// import DamagedAnalysis from './DamagedAnalysis';
 
// const DamagedModuleTabsComponent = () => {
//   const tabs = [
//     { label: 'Damaged Modules Form', component: <DamagedForm /> },
//     { label: 'Damaged Modules Analysis', component: <DamagedAnalysis /> },
//   ];
 
//   return (
//     <ReusableTabs
//       tabs={tabs}
//       defaultTab={0}
//       panelStyles={{ padding: '16px' }}
//     />
//   );
// };
 
// export default DamagedModuleTabsComponent;

import React, { useState, useEffect } from 'react';
import ReusableTabs from '../../../pages/ReusableTabs';
import DamagedForm from './DamagedForm';
import DamagedAnalysis from './DamagedAnalysis';

const DamagedModuleTabsComponent = () => {
  const [canEditForm, setCanEditForm] = useState(false);

  useEffect(() => {
    const storedRoles = sessionStorage.getItem("userRoles");
    if (storedRoles) {
      let roles = [];
      try {
        const parsed = JSON.parse(storedRoles);
        if (Array.isArray(parsed)) roles = parsed;
      } catch {
        roles = storedRoles.split(",").map(r => r.trim());
      }
      setCanEditForm(roles.includes("Damaged_Modules_Form_Edit"));
    }
  }, []);

  const tabs = [
    ...(canEditForm
      ? [{ label: 'Damaged Modules Form', component: <DamagedForm /> }]
      : []
    ),
    { label: 'Damaged Modules Analysis', component: <DamagedAnalysis /> },
  ];

  return (
    <ReusableTabs
      tabs={tabs}
      defaultTab={0}
      panelStyles={{ padding: '16px' }}
    />
  );
};

export default DamagedModuleTabsComponent;